import React, { Component } from 'react';
import * as settings from '../../settings';
import _includes from 'lodash/includes';

import styles from './GamePlayer.scss';
import GameEnd from 'Components/GameEnd';

class GamePlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blockedKeyCodes: [],
    };

    this.receiveMessage = this.receiveMessage.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }
  componentDidMount() {
    window.addEventListener('message', this.receiveMessage, false);
    if (this.props.externalContent !== true) {
      window.addEventListener('keydown', this.onKeydown, false);
      window.addEventListener('keyup', this.onKeyup, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { restartGame } = this.props;
    if (restartGame && restartGame !== prevProps.restartGame) {
      this.gameIframe.contentWindow.postMessage(
        { restartGame: true },
        settings.CONTENT_URL
      );
      this.props.onGameRestart();
    }
  }

  receiveMessage(event) {
    // For Chrome, the origin property is in the event.originalEvent object.
    var origin = event.origin || event.originalEvent.origin;
    if (origin !== settings.CONTENT_URL) return;

    if (
      typeof event.data === 'object' &&
      event.data !== null &&
      event.data.gameOver
    ) {
      const playerWon =
        typeof event.data.playerWon !== 'undefined'
          ? event.data.playerWon
          : false;
      const showEndCard =
        typeof event.data.showEndCard !== 'undefined'
          ? event.data.showEndCard
          : true;
      this.props.onEndGame({ playerWon, showEndCard });
    }

    if (typeof event.data === 'object' && event.data.gameRestarted) {
      this.props.onGameRestart();
    }

    if (typeof event.data === 'object' && event.data.blockedKeyCodes) {
      this.setState({ blockedKeyCodes: event.data.blockedKeyCodes });
    }

    if (typeof event.data === 'object' && event.data.refreshAds) {
      this.props.refreshAds();
    }
  }

  onKeydown(event) {
    if (_includes(this.state.blockedKeyCodes, event.keyCode)) {
      event.preventDefault();
    }
    this.gameIframe.contentWindow.postMessage(
      {
        eventType: 'keydown',
        keyCode: event.keyCode,
      },
      settings.CONTENT_URL
    );
  }

  onKeyup(event) {
    this.gameIframe.contentWindow.postMessage(
      {
        eventType: 'keyup',
        keyCode: event.keyCode,
      },
      settings.CONTENT_URL
    );
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
    if (this.props.externalContent !== true) {
      window.removeEventListener('keydown', this.onKeydown, false);
      window.removeEventListener('keyup', this.onKeyup, false);
    }
  }

  render() {
    const {
      width,
      height,
      additionalClasses,
      slug,
      skipPreContentAd,
    } = this.props;
    let { embedURI } = this.props;
    let paddingStyle = null;
    if (width && height) {
      const padding = ((height / width) * 100).toFixed(4) + '%';
      paddingStyle = (
        <style>{`.GamePlayer:before { padding-top: ${padding}}`}</style>
      );
    }
    if (settings.LOCAL_CONTENT) {
      embedURI = embedURI.replace(
        settings.CONTENT_URL_PROD,
        settings.CONTENT_URL_LOCAL
      );
      embedURI = embedURI.replace('/games', '');
    }
    embedURI = embedURI.replace(
      'content.funbrain.com',
      'www.funbrain.com/content'
    );

    return (
      <div className={`GamePlayer ${additionalClasses}`}>
        <GameEnd {...this.props} />
        {paddingStyle}
        <iframe
          title={slug}
          className="GamePlayer__iframe"
          id="game-frame"
          src={embedURI}
          ref={iframe => {
            this.gameIframe = iframe;
          }}
        />
      </div>
    );
  }
}

export default GamePlayer;
